export const brandInfo = {
  name: "91看网页版",
  subtitle: "您的在线影视观看首选平台",
  description: "91看网页版成立于2020年，是国内领先的在线影视观看平台。我们致力于为用户提供高清、流畅、便捷的在线视频观看服务，无需下载安装任何软件，直接通过浏览器即可畅享海量优质内容。",
  mission: "让每个人都能轻松享受高质量的在线影视内容",
  vision: "成为国内最受用户信赖的在线影视平台",
  values: ["用户至上", "内容为王", "技术创新", "诚信经营"],
  foundedYear: 2020,
};

export const reputationItems = [
  {
    id: 1,
    name: "张先生",
    avatar: "https://readdy.ai/api/search-image?query=A%20friendly%20Chinese%20male%20portrait%20avatar%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20yet%20approachable%20style&width=80&height=80&seq=avatar-user-01&orientation=squarish",
    rating: 5,
    content: "用了91看网页版两年多了，画质清晰流畅，片源更新快，分类也很齐全。最重要的是不用下载APP，打开浏览器就能看，太方便了！强烈推荐给喜欢在线看电影的朋友。",
    date: "2025-06-20",
  },
  {
    id: 2,
    name: "李女士",
    avatar: "https://readdy.ai/api/search-image?query=A%20warm%20Chinese%20female%20portrait%20avatar%2C%20soft%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20professional%20style&width=80&height=80&seq=avatar-user-02&orientation=squarish",
    rating: 5,
    content: "界面简洁好用，没有乱七八糟的广告，这点真的很棒。资源丰富从国产剧到海外大片应有尽有。电脑、平板、手机都能用，非常方便。",
    date: "2025-06-18",
  },
  {
    id: 3,
    name: "王先生",
    avatar: "https://readdy.ai/api/search-image?query=A%20casual%20Chinese%20male%20portrait%20avatar%2C%20warm%20natural%20lighting%2C%20clean%20background%2C%20everyday%20style&width=80&height=80&seq=avatar-user-03&orientation=squarish",
    rating: 4,
    content: "朋友推荐的平台，确实不错。画质好加载快，片库也够大。偶尔周末在家连着看几部电影，体验很流畅。希望以后能有更多独家内容。",
    date: "2025-06-15",
  },
  {
    id: 4,
    name: "赵女士",
    avatar: "https://readdy.ai/api/search-image?query=A%20modern%20Chinese%20female%20portrait%20avatar%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20background%2C%20contemporary%20professional%20look&width=80&height=80&seq=avatar-user-04&orientation=squarish",
    rating: 5,
    content: "作为影视爱好者，91看网页版是我日常观影的首选。分类做得特别好，找片很方便。电视剧、电影、综艺、动漫都有，资源很全。最近更新的速度也越来越快了。",
    date: "2025-06-12",
  },
  {
    id: 5,
    name: "陈先生",
    avatar: "https://readdy.ai/api/search-image?query=A%20Chinese%20male%20portrait%20avatar%20with%20glasses%2C%20warm%20indoor%20lighting%2C%20clean%20background%2C%20intellectual%20style&width=80&height=80&seq=avatar-user-05&orientation=squarish",
    rating: 5,
    content: "用了很多在线影视平台，91看网页版是最稳定的。播放不卡顿、画质可选择、界面操作流畅。还能记住观看进度，下次接着看很贴心。强烈推荐！",
    date: "2025-06-10",
  },
  {
    id: 6,
    name: "刘女士",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20female%20portrait%20avatar%2C%20bright%20warm%20lighting%2C%20clean%20background%2C%20fresh%20and%20youthful%20style&width=80&height=80&seq=avatar-user-06&orientation=squarish",
    rating: 4,
    content: "下班回家打开浏览器就能看电影，不用下载安装，太省心了。片源丰富画质好，周末宅家必备。推荐了身边好多朋友都在用。",
    date: "2025-06-08",
  },
];

export const contactInfo = {
  email: "service@91kan.com",
  phone: "400-888-9191",
  wechat: "91kan_official",
  address: "北京市朝阳区建国路88号SOHO现代城A座18层",
  workingHours: "周一至周日 9:00 - 22:00",
};

export const faqItems = [
  {
    question: "91看网页版需要下载安装吗？",
    answer: "完全不需要！91看网页版是基于浏览器的在线影视平台，您只需要打开浏览器访问我们的网站，即可立即开始观看海量高清视频内容，无需下载任何软件或插件。",
  },
  {
    question: "91看网页版支持哪些设备？",
    answer: "91看网页版支持所有主流设备，包括Windows/Mac电脑、iPhone/Android手机、iPad/Android平板等。只要您的设备上有现代浏览器（Chrome、Safari、Edge、Firefox等），就可以流畅访问和观看。",
  },
  {
    question: "视频画质如何？支持高清播放吗？",
    answer: "91看网页版支持多种清晰度选择，包括标清、高清和超清。我们采用先进的视频编码和CDN加速技术，确保在不同网络环境下都能获得流畅清晰的观影体验。大部分内容都支持1080P高清播放。",
  },
  {
    question: "91看网页版的内容更新频率如何？",
    answer: "我们拥有专业的内容运营团队，每天都会更新最新最热的影视内容。热门剧集通常在播出后24小时内上线，电影也会在院线下映后尽快上线。您可以随时关注首页推荐获取最新更新信息。",
  },
  {
    question: "91看网页版是否免费？",
    answer: "91看网页版提供大量免费内容供用户观看。同时，我们也提供VIP会员服务，会员可以享受更高画质、独家内容和免广告等特权。具体费用请查看会员中心页面。",
  },
  {
    question: "91看网页版的入口地址在哪里？",
    answer: "91看网页版的官方入口地址就是您当前访问的网址。建议您将我们的网址添加到浏览器收藏夹，以便随时访问。如遇地址变更，我们会通过官方渠道及时通知用户。",
  },
  {
    question: "观看过程中遇到卡顿怎么办？",
    answer: "如果遇到播放卡顿，您可以尝试以下方法：1）降低视频清晰度；2）检查您的网络连接；3）关闭其他占用带宽的应用；4）刷新页面重新加载。如问题持续，请联系我们的客服获取帮助。",
  },
];